const s = {
  name: "Watch",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11.2,20c0,0.7-0.6,1.2-1.2,1.2S8.8,20.7,8.8,20c0-0.7,0.6-1.2,1.2-1.2S11.2,19.3,11.2,20z"/>
		<path class="st0" d="M14,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2C12.8,20.7,13.3,21.2,14,21.2z"/>
		<path class="st0" d="M19.2,20c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2S19.2,19.3,19.2,20z"/>
		<path class="st0" d="M19.8,0H8.2L6.4,8.3C2.5,10.8,0,15.1,0,20c0,4.9,2.5,9.2,6.4,11.7L8.2,40h11.6l1.8-8.3
			C25.5,29.2,28,24.9,28,20c0-4.9-2.5-9.2-6.4-11.7L19.8,0z M9.8,38l-1.1-5c1.6,0.7,3.4,1,5.3,1s3.7-0.4,5.3-1l-1.1,5H9.8z M19.3,7
			c-1.6-0.7-3.4-1-5.3-1s-3.7,0.4-5.3,1l1.1-5h8.4L19.3,7z M14,8c6.6,0,12,5.4,12,12c0,6.6-5.4,12-12,12C7.4,32,2,26.6,2,20
			C2,13.4,7.4,8,14,8z"/>
		<path class="st0" d="M32,24h-2v-8h2V24z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Watch
};
